import { render, staticRenderFns } from "./mindex.vue?vue&type=template&id=2ea1b330"
import script from "./mindex.vue?vue&type=script&lang=js"
export * from "./mindex.vue?vue&type=script&lang=js"
import style0 from "./mindex.vue?vue&type=style&index=0&id=2ea1b330&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports